import { render, staticRenderFns } from "./ExportSuccessNotification.vue?vue&type=template&id=1a21ea24&scoped=true&"
import script from "./ExportSuccessNotification.vue?vue&type=script&lang=js&"
export * from "./ExportSuccessNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a21ea24",
  null
  
)

export default component.exports